import { render, staticRenderFns } from "./GoodsDetail.vue?vue&type=template&id=3cc7a2d0&scoped=true"
import script from "./GoodsDetail.vue?vue&type=script&lang=js"
export * from "./GoodsDetail.vue?vue&type=script&lang=js"
import style0 from "./GoodsDetail.vue?vue&type=style&index=0&id=3cc7a2d0&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cc7a2d0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/test-crmeb-admin-front-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3cc7a2d0')) {
      api.createRecord('3cc7a2d0', component.options)
    } else {
      api.reload('3cc7a2d0', component.options)
    }
    module.hot.accept("./GoodsDetail.vue?vue&type=template&id=3cc7a2d0&scoped=true", function () {
      api.rerender('3cc7a2d0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/store/creatStore/steps/GoodsDetail.vue"
export default component.exports